import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCamera,
  faDroplet,
  faSnowflake,
} from "@fortawesome/free-solid-svg-icons";

import "./StationTypeIndicator.css";
import { blue } from "../../sass/colors";

function StationTypeIndicator({ stationInfo }) {
  const nameParts = [];
  if (!!stationInfo?.sensors?.find((s) => s.active && s.parameter === 2))
    nameParts.push("Niveau");
  if (!!stationInfo?.sensors?.find((s) => s.active && s.parameter === 3))
    nameParts.push("Débit");
  return (
    <span className={"station-type-indicator"}>
      {!!stationInfo?.sensors?.find(
        (s) =>
          s.active &&
          [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17].includes(s.parameter)
      ) && <FontAwesomeIcon icon={faSnowflake} color={blue} />}
      {!!stationInfo?.sensors?.find(
        (s) => s.active && [2, 3, 4, 18, 19].includes(s.parameter)
      ) && (
        <FontAwesomeIcon
          icon={faDroplet}
          color={blue}
          title={nameParts.join("|") || ""}
        />
      )}
      {!!stationInfo?.cameraViews?.length && (
        <FontAwesomeIcon icon={faCamera} color={blue} />
      )}
    </span>
  );
}

export default StationTypeIndicator;
